import { ICitation } from '@vivli/shared/features/citations/infrastructure/interface';
import { useCitation } from '@vivli/shared/features/citations/infrastructure/hook';
import { Color, Size } from '@vivli/shared/theme';
import { CSSProperties } from 'react';
import Tippy from '@tippyjs/react';

const citationStyleGeneric: CSSProperties = {
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    flexWrap: 'wrap',
    color: Color.VIVLI_PUBLISHED_DARKBLUE,
    marginRight: '10px',
    backgroundColor: Color.TRANSPARENT,
};

const citationBodyStyle: CSSProperties = {
    ...citationStyleGeneric,
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
};

const citationJournalStyle: CSSProperties = {
    ...citationStyleGeneric,
    fontStyle: 'italic',
};

const citationTitleStyle: CSSProperties = {
    ...citationStyleGeneric,
    marginRight: '0px',
    minWidth: '0px',
    maxWidth: '100%',
    whiteSpace: 'normal',
};

interface CitationComponentProps {
    citation: ICitation;
}

/// This component is used to display a citation in a
// published approved data request context.
// Styling and arrangement of text is set up for that.
export const PublishedCitationComponent = ({ citation }: CitationComponentProps) => {
    const { formattedAuthors, formattedJournal, formattedDoi } = useCitation(citation);
    const formattedAuthorsString = formattedAuthors(false);
    const formattedJournalString = formattedJournal(true);
    const formattedDoiString = formattedDoi();
    const titleText = citation ? `"${citation?.title}".` : '-';
    const noDoi = formattedDoiString === '-';

    return (
        <div style={{ width: '100%' }}>
            <Tippy content={formattedAuthorsString}>
                <div style={citationBodyStyle}>{formattedAuthorsString}</div>
            </Tippy>
            <div style={citationTitleStyle}>{titleText}</div>
            <div>
                <span style={citationJournalStyle}>{citation?.journal}</span>
                <span style={citationStyleGeneric}>{formattedJournalString}</span>
            </div>
            <div style={citationStyleGeneric}>
                {!noDoi && (
                    <a href={formattedDoiString} target="_blank">
                        doi: {formattedDoiString}
                    </a>
                )}
                {noDoi && (
                    <a href={citation?.url} target="_blank">
                        url: {citation?.url}
                    </a>
                )}
            </div>
        </div>
    );
};
